export default {
  id: 13,
  pride: 6144,
  slug: "online-text-to-speech",
  category: "tool",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "在线语音合成",
    en: "Online Text-to-Speech"
  },
  image: require('@/assets/images/tts.webp'),
  descriptionKey: {
    zh: "在线语音合成，基于微软Edge。",
    en: "Online text-to-speech synthesis based on Microsoft Edge."
  },
  date: { year: 2024, month: 10 },
  genres: ["语音合成", "工具"],
  themes: ["TTS"],
  engine: "Web",
  platform: ["Web"],
  tags: ["自用工具"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "web", url: "https://tts.tobenot.top/", textKey: { zh: "在线使用", en: "Use Online" } }
  ]
};
